import { render, staticRenderFns } from "./PromotionalLaboralDashboard.vue?vue&type=template&id=8cda1ab6&scoped=true&"
import script from "./PromotionalLaboralDashboard.vue?vue&type=script&lang=js&"
export * from "./PromotionalLaboralDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalLaboralDashboard.vue?vue&type=style&index=0&id=8cda1ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cda1ab6",
  null
  
)

export default component.exports